import { ActionButton, actionButtonStyles } from "./ActionButton";

interface SaveCancelButtonsProps {
  onSave: () => void;
  onCancel: () => void;
  dirty: boolean;
  saving: boolean;
}

export function SaveCancelButtons({ onSave, onCancel, dirty, saving }: SaveCancelButtonsProps) {
  const saveDisabled = !dirty || saving;

  return (
    <>
      <ActionButton
        icon="close"
        onPress={onCancel}
        tooltip="Cancel"
        style={actionButtonStyles.iconBtn}
        tooltipOffsetX={-12}
      />
      <ActionButton
        icon="check"
        onPress={onSave}
        tooltip="Save"
        tooltipOffsetX={-5}
        style={[actionButtonStyles.iconBtn, { opacity: saveDisabled ? 0.5 : 1 }]}
        disabled={saveDisabled}
      />
    </>
  );
}
